import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@chakra-ui/react';
export const CheckoutHeading = (props) => (_jsx(Text, { fontSize: 22, fontWeight: 500, children: props.children }));
